import _ from 'lodash';
import qs from 'qs';

function toQuery(filter, pagination, sorting, defaultFilter) {
  const query = {};

  if (filter) {
    for (const pair of filter.entries()) {
      if (!pair[1]) continue;
      if (_.get(defaultFilter, pair[0]) === pair[1]) continue;

      query[`f-${pair[0]}`] = pair[1];
    }
  }

  if (sorting) {
    for (const pair of sorting.entries()) {
      if (!pair[1]) continue;

      query[`s-${pair[0]}`] = pair[1];
    }
  }

  if (pagination && pagination.currentPage > 1) {
    query['p'] = pagination.currentPage;
  }

  return query;
}

function saveStateToUrl(history, filter, pagination, sorting, defaultFilter) {
  const query = qs.parse(history.location.search, {ignoreQueryPrefix: true});

  Object.keys(query).forEach(key => {
    if (key.startsWith('f-') || key.startsWith('s-') || key === 'p') {
      delete query[key];
    }
  });

  Object.assign(query, toQuery(filter, pagination, sorting, defaultFilter));

  history.replace({...history.location, search: qs.stringify(query)});
}

export default saveStateToUrl;
